import winterGroupsService from "../shared/services/winterGroupsService";

const REQUEST_WINTER_GROUPS = "REQUEST_WINTER_GROUPS";
const RESPONSE_WINTER_GROUPS = "RESPONSE_WINTER_GROUPS";
const REQUEST_WINTER_GROUPS_FAILURE = "REQUEST_WINTER_GROUPS_FAILURE";

const requestWinterGroupsAction = () => {
  return {
    type: REQUEST_WINTER_GROUPS,
  };
};

const responseWinterGroupsAction = (data) => {
  return {
    type: RESPONSE_WINTER_GROUPS,
    data,
  };
};

const requestWinterGroupsFailureAction = (errors) => {
  return {
    type: REQUEST_WINTER_GROUPS_FAILURE,
    errors,
  };
};

const getWinterGroups = (options) => {
  return (dispatch) => {
    dispatch(requestWinterGroupsAction());

    winterGroupsService
      .getWinterGroups(options)
      .then((result) => {
        dispatch(responseWinterGroupsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestWinterGroupsFailureAction(error.response));
      });
  };
};

const SELECT_WINTER_GROUPS = "SELECT_WINTER_GROUPS";

const requestSelectWinterGroupsAction = (data) => {
  return {
    type: SELECT_WINTER_GROUPS,
    data,
  };
};

const selectWinterGroup = (winterGroup) => {
  return (dispatch) => {
    dispatch(requestSelectWinterGroupsAction(winterGroup));
  };
};

const REQUEST_ADD_WINTER_UNIT_GROUP = "REQUEST_ADD_WINTER_UNIT_GROUP";
const RESPONSE_ADD_WINTER_UNIT_GROUP = "RESPONSE_ADD_WINTER_UNIT_GROUP";
const REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE = "REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE";

const requestAddAction = () => {
  return {
    type: REQUEST_ADD_WINTER_UNIT_GROUP,
  };
};

const responseAddAction = (unit, group) => {
  return {
    type: RESPONSE_ADD_WINTER_UNIT_GROUP,
    unit,
    group,
  };
};

const requestAddFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE,
    errors,
  };
};

const addWinterUnitGroup = (unit, group) => {
  return (dispatch) => {
    dispatch(requestAddAction());

    winterGroupsService
      .addUnitWinterGroup({ unitId: unit.id, groupId: group.id })
      .then((result) => {
        dispatch(responseAddAction(unit, group));
      })
      .catch((error) => {
        dispatch(requestAddFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_WINTER_UNIT_GROUP = "REQUEST_DELETE_WINTER_UNIT_GROUP";
const RESPONSE_DELETE_WINTER_UNIT_GROUP = "RESPONSE_DELETE_WINTER_UNIT_GROUP";
const REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE = "REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE";

const requestDeleteAction = () => {
  return {
    type: REQUEST_DELETE_WINTER_UNIT_GROUP,
  };
};

const responseDeleteAction = (unit, group) => {
  return {
    type: RESPONSE_DELETE_WINTER_UNIT_GROUP,
    unit,
    group,
  };
};

const requestDeleteFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE,
    errors,
  };
};

const deleteWinterUnitGroup = (unit, group) => {
  return (dispatch) => {
    dispatch(requestDeleteAction());

    winterGroupsService
      .deleteUnitWinterGroup({ unitId: unit.id, groupId: group.id })
      .then((result) => {
        dispatch(responseDeleteAction(unit, group));
      })
      .catch((error) => {
        dispatch(requestDeleteFailureAction(error.response));
      });
  };
};

export {
  REQUEST_WINTER_GROUPS,
  RESPONSE_WINTER_GROUPS,
  REQUEST_WINTER_GROUPS_FAILURE,
  getWinterGroups,
  SELECT_WINTER_GROUPS,
  selectWinterGroup,
  REQUEST_ADD_WINTER_UNIT_GROUP,
  RESPONSE_ADD_WINTER_UNIT_GROUP,
  REQUEST_ADD_WINTER_UNIT_GROUP_FAILURE,
  addWinterUnitGroup,
  REQUEST_DELETE_WINTER_UNIT_GROUP,
  RESPONSE_DELETE_WINTER_UNIT_GROUP,
  REQUEST_DELETE_WINTER_UNIT_GROUP_FAILURE,
  deleteWinterUnitGroup,
};
